import { Component, OnInit } from '@angular/core';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogModule,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import {
    FormsModule,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { TalentPool } from '../../../../../../../../shared/interfaces/talent-pool.interface';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { UserService } from '../../../../../../../../shared/services/user.service';
import { PipesModule } from '../../../../../../../../shared/pipes/pipes.module';

@Component({
    selector: 'offer-confirmation-modal',
    providers: [DialogService],
    standalone: true,
    imports: [
        FloatLabelModule,
        DialogModule,
        ButtonModule,
        FormsModule,
        InputTextModule,
        CommonModule,
        DynamicDialogModule,
        DropdownModule,
        CalendarModule,
        InputSwitchModule,
        MultiSelectModule,
        PipesModule
    ],
    templateUrl: './talent-pool-modal.component.html',
    styleUrl: './talent-pool-modal.component.scss'
})
export class TalentpoolModalComponent implements OnInit {

    talentPools: Array<TalentPool> = [];
    filteredPools: Array<TalentPool> = [];
    selectedPools: Array<TalentPool> = [];
    onChangeTalentPool: Function | null = null;
    sessionUser: any = null;

    constructor(
        public ref: DynamicDialogRef,
        public dialogService: DialogService,
        public config: DynamicDialogConfig,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.sessionUser = this.userService.getSessionUser();
        this.talentPools = this.config?.data?.talentPools;
        this.filteredPools = [...this.talentPools];
        this.onChangeTalentPool = this.config?.data?.onChangeTalentPool;
        const selectedIds = this.config?.data?.selectedPoolIds;
        if(selectedIds.length){
            selectedIds.forEach((e: string) => {
                const talentPool = this.filteredPools.find((tp: any) => e === tp._id);
                if(talentPool){
                    this.selectedPools.push(talentPool);
                }
            })
        }
    }

    closeDialog() {
        if (this.selectedPools.length) {
            this.ref.close({
                talentPools: this.talentPools
            });
            this.selectedPools = [];
            return;
        }
        this.selectedPools = [];
        this.ref.close();

    }

    onToggleChange(e: any){
        if(e.checked){
            this.selectedPools = [];
            this.filteredPools = this.talentPools.filter(pool => pool.createdBy === this.sessionUser._id);
        } else {
            this.selectedPools = [];
            this.filteredPools = [...this.talentPools];
        }
    }

    onChangeTanentPools(): void {
        if(this.onChangeTalentPool){
            this.onChangeTalentPool(this.selectedPools.map(pool => pool._id));
        }
    }

    getCommaSeparatedNamesOfSelectedPool(): string{
        return this.selectedPools.map(pool => pool.name).join(', ');
    }
}
